import {
  User,
  Users,
  Settings,
  Eye,
  FileCode,
  UserCog,
  UserPlus,
  Building,
  BookOpen,
  Plus,
  BarChart3,
  FileText,
  Calendar,
  History,
  TestTube,
  GraduationCap,
  FolderPlus,
  CalendarCheck,
  Rocket,
  Play,
  Code,
  HelpCircle,
  Puzzle,
  Notebook,
  Target,
  UserCircle,
  Trash2,
  UserCheck,
  UsersIcon,
  BrainCircuit,
  Sparkles,
  Tag,
  TrendingUp,
  FileUp,
  FilePlus,
  BriefcaseBusiness,
  Search,
  Kanban,
  Briefcase,
  PlusCircle,
  CheckCircle,
  Edit,
  PenTool,
  Library,
  Database,
  ClipboardCheck,
  Crown,
  Shield,
  LayoutDashboard,
  Wand2,
  ShieldCheck,
  ShieldAlert,
  Building2,
  LayoutGrid,
  List,
  PlusSquare,
  ShoppingCart,
  Globe,
} from "lucide-react";
import type { JSX } from "react";

export type UserRole =
  | "admin"
  | "student"
  | "client"
  | "author"
  | "moderator"
  | "content_head"
  | "super_admin"
  | "business_unit"
  | "enterprise_admin";

type NavigationItem = {
  kind?: "section" | "divider";
  segment?: string;
  title: string;
  icon?: JSX.Element;
  children?: NavigationItem[];
  path?: string;
};

type NavigationSection = {
  title: string;
  items: NavigationItem[];
};

type Navigation = NavigationSection[];

const ADMIN_NAVIGATION: Navigation = [
  {
    title: "Dashboard",
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    title: "Organization & Access Control",
    items: [
      {
        segment: "users",
        path: "/users",
        title: "Users Management",
        icon: <Users className="w-4 h-4" />,
        children: [
          {
            segment: "users",
            path: "/users",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "users/create",
            path: "/users/create",
            title: "Add Client User",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "clients",
        path: "/clients",
        title: "Clients Management",
        icon: <Building className="w-4 h-4" />,
        children: [
          {
            segment: "clients",
            path: "/clients",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
          // {
          //   segment: "clients/create",
          //   path: "/clients/create",
          //   title: "Create",
          //   icon: <Plus className="w-3 h-3" />,
          // },
        ],
      },

      {
        segment: "recruitment-agencies",
        path: "/recruitment",
        title: "Recruitment Agencies",
        icon: <Briefcase className="w-4 h-4" />, // <--- Updated Icon
        children: [
          {
            segment: "recruitment",
            path: "/recruitment/view-agencies",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "recruitment/create-agency",
            path: "/recruitment/create-agency",
            title: "Create",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },

      {
        segment: "students",
        path: "/students",
        title: "Students Management",
        icon: <GraduationCap className="w-4 h-4" />, // Import from lucide-react
        children: [
          {
            segment: "students/agency-linked",
            path: "/students/agency-linked",
            title: "Agency Linked",
            icon: <Briefcase className="w-3 h-3" />,
          },
          {
            segment: "students/college-linked",
            path: "/students/college-linked",
            title: "College Linked",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "students/individuals",
            path: "/students/individuals",
            title: "Individuals (Plan)",
            icon: <User className="w-3 h-3" />,
          },
        ],
      },

      {
        segment: "author-management",
        path: "/author-management",
        title: "Authors Management",
        icon: <UserCircle className="w-4 h-4" />,
        children: [
          {
            segment: "author-management/add-author",
            path: "/author-management/add-author",
            title: "Add Author",
            icon: <UserPlus className="w-3 h-3" />,
          },
          {
            segment: "author-management/view-authors",
            path: "/author-management/view-authors",
            title: "View Authors",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "author-management/add-moderator",
            path: "/author-management/add-moderator",
            title: "Add Moderator",
            icon: <Settings className="w-3 h-3" />,
          },
          {
            segment: "author-management/view-moderator",
            path: "/author-management/view-moderator",
            title: "View Moderators",
            icon: <UserCog className="w-3 h-3" />,
          },

          // {
          //   segment: "author-management/delete-author",
          //   path: "/author-management/delete-author",
          //   title: "Delete Author",
          //   icon: <Trash2 className="w-3 h-3" />,
          // },
          // {
          //   segment: "author-management/delete-moderator",
          //   path: "/author-management/delete-moderator",
          //   title: "Delete Moderator",
          //   icon: <Trash2 className="w-3 h-3" />,
          // },
          {
            segment: "author-management/summary",
            path: "/author-management/summary",
            title: "Summary",
            icon: <FileCode className="w-3 h-3" />,
          },
        ],
      },

      // ✅ NEW SEPARATE SECTION: Content Head Management
      {
        segment: "content-head",
        path: "/content-head",
        title: "Content Head Management",
        icon: <Crown className="w-4 h-4" />,
        children: [
          {
            segment: "content-head/add",
            // Make sure this matches your Route definition
            path: "/author-management/add-content-head",
            title: "Add Content Head",
            icon: <Plus className="w-3 h-3" />,
          },
          {
            segment: "content-head/view",
            // Make sure this matches your Route definition
            path: "/author-management/view-content-head",
            title: "View Content Heads",
            icon: <Shield className="w-3 h-3" />,
          },
        ],
      },
      // ✅ NEW SEPARATE SECTION: Super Access Management
      {
        segment: "super-access",
        path: "/super-access",
        title: "Super Access Management",
        icon: <ShieldAlert className="w-4 h-4" />, // Make sure to import ShieldAlert from 'lucide-react'
        children: [
          {
            segment: "super-access/add",
            path: "/author-management/add-super-access",
            title: "Add Super Admin",
            icon: <Plus className="w-3 h-3" />,
          },
          {
            segment: "super-access/view",
            path: "/author-management/view-super-access",
            title: "View Super Admins",
            icon: <ShieldCheck className="w-3 h-3" />, // Make sure to import ShieldCheck
          },
        ],
      },
      {
        segment: "enterprise-admin",
        path: "/enterprise-admin",
        title: "Enterprise Admin Management",
        icon: <Building className="w-4 h-4" />, // Make sure to import Building from 'lucide-react'
        children: [
          {
            segment: "enterprise-admin/add",
            path: "/author-management/add-enterprise-admin",
            title: "Add Enterprise Admin",
            icon: <Plus className="w-3 h-3" />,
          },
          {
            segment: "enterprise-admin/view",
            path: "/author-management/view-enterprise-admin",
            title: "View Enterprise Admins",
            icon: <Briefcase className="w-3 h-3" />, // Make sure to import Briefcase from 'lucide-react'
          },
          {
            segment: "enterprise-admin/review-licenses",
            path: "/author-management/review-licenses",
            title: "Review License Requests",
            icon: <ShieldCheck className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Assessment Architecture",
    items: [
      {
        segment: "client/sections",
        path: "/client/sections",
        title: "Sections",
        icon: <Notebook className="w-4 h-4" />,
        children: [
          {
            segment: "client/sections",
            path: "/client/sections",
            title: "View Sections",
            icon: <BookOpen className="w-3 h-3" />,
          },
          {
            segment: "client/sections/create",
            path: "/client/sections/create",
            title: "Add New Section",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/patterns",
        path: "/client/patterns",
        title: "Patterns",
        icon: <Puzzle className="w-4 h-4" />,
        children: [
          {
            segment: "client/patterns",
            path: "/client/patterns",
            title: "Patterns",
            icon: <Target className="w-3 h-3" />,
          },
          {
            segment: "client/patterns/create",
            path: "/client/patterns/create",
            title: "Create Pattern",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/assessmentsv2",
        path: "/client/assessmentsv2",
        title: "Assessments",
        icon: <TestTube className="w-4 h-4" />,
        children: [
          {
            segment: "client/assessmentsv2",
            path: "/client/assessmentsv2",
            title: "View Assessments",
            icon: <GraduationCap className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/create",
            path: "/client/assessmentsv2/create",
            title: "Create Assessment",
            icon: <FolderPlus className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/scheduleAssessment",
            path: "/client/assessmentsv2/scheduleAssessment",
            title: "Schedule Assessment",
            icon: <CalendarCheck className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/launchAssessment",
            path: "/client/assessmentsv2/launchAssessment",
            title: "Launch Assessment",
            icon: <Rocket className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/runningAssessment",
            path: "/client/assessmentsv2/runningAssessment",
            title: "Running Assessment",
            icon: <Play className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Content Management",
    items: [
      {
        segment: "question-bank-overview",
        path: "/admin/question-bank-overview",
        title: "Question Bank Summary", // New Analytics Dashboard
        icon: <BarChart3 className="w-4 h-4" />,
      },
      {
        segment: "questions",
        path: "/author/questions", // Corrected to admin path for consistency
        title: "Global Question Bank",
        icon: <Database className="w-4 h-4" />,
      },
    ],
  },
  // {
  //   title: "Authored Content",
  //   items: [
  //     {
  //       segment: "coding-problems",
  //       path: "/coding-problems",
  //       title: "Coding Problems",
  //       icon: <Code className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "coding-problems",
  //           path: "/coding-problems",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         // {
  //         //   segment: "coding-problems/create",
  //         //   path: "/coding-problems/create",
  //         //   title: "Create",
  //         //   icon: <Plus className="w-3 h-3" />,
  //         // },
  //       ],
  //     },
  //     {
  //       segment: "mcq-problems",
  //       path: "/mcq-problems",
  //       title: "MCQ Problems",
  //       icon: <HelpCircle className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "mcq-problems",
  //           path: "/mcq-problems",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         // {
  //         //   segment: "mcq-problems/create",
  //         //   path: "/mcq-problems/create",
  //         //   title: "Create",
  //         //   icon: <Plus className="w-3 h-3" />,
  //         // },
  //       ],
  //     },
  //     {
  //       segment: "question-bank-overview",
  //       path: "/question-bank-overview",
  //       title: "Question Bank Overview",
  //       icon: <BookOpen className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "question-bank-overview/mcq",
  //           path: "/question-bank-overview/mcq",
  //           title: "MCQ Questions",
  //           icon: <HelpCircle className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "question-bank-overview/coding",
  //           path: "/question-bank-overview/coding",
  //           title: "Coding Questions",
  //           icon: <Code className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "Pragna-AI Content",
  //   items: [
  //     {
  //       segment: "coding-problems/ai",
  //       path: "/coding-problems/ai",
  //       title: "AI Coding Problems",
  //       icon: <BrainCircuit className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "coding-problems/ai",
  //           path: "/coding-problems/ai",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         // {
  //         //   segment: "coding-problems/ai/create",
  //         //   path: "/coding-problems/ai/create",
  //         //   title: "Create",
  //         //   icon: <Plus className="w-3 h-3" />,
  //         // },
  //       ],
  //     },
  //     {
  //       segment: "mcq-problems/ai",
  //       path: "/mcq-problems/ai",
  //       title: "AI MCQ Problems",
  //       icon: <Sparkles className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "mcq-problems/ai",
  //           path: "/mcq-problems/ai",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         // {
  //         //   segment: "mcq-problems/ai/create",
  //         //   path: "/mcq-problems/ai/create",
  //         //   title: "Create",
  //         //   icon: <Plus className="w-3 h-3" />,
  //         // },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "Reports & Analytics",
    items: [
      {
        segment: "client/reports",
        path: "/client/reports",
        title: "Reports",
        icon: <BarChart3 className="w-4 h-4" />,
        children: [
          {
            segment: "client/reports/client-wise",
            path: "/client/reports/client-wise",
            title: "Client Wise",
            icon: <Users className="w-3 h-3" />,
          },
          {
            segment: "client/reports/assessment-wise",
            path: "/client/reports/assessment-wise",
            title: "Assessment Wise",
            icon: <BarChart3 className="w-3 h-3" />,
          },
          {
            segment: "client/reports/student-wise",
            path: "/client/reports/student-wise",
            title: "Student Wise",
            icon: <FileText className="w-3 h-3" />,
          },
          {
            segment: "client/reports/make-my-report",
            path: "/client/reports/make-my-report",
            title: "Make My Report",
            icon: <Target className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "fitment-analysis",
        path: "/fitment-analysis",
        title: "Fitment Analysis",
        icon: <TrendingUp className="w-4 h-4" />,
        children: [
          {
            segment: "fitment-analysis/content-fitment-analysis",
            path: "/fitment-analysis/content-fitment-analysis",
            title: "Skill Fitment Analysis",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/company-fitment-analysis",
            path: "/fitment-analysis/company-fitment-analysis",
            title: "Company Fitment Analysis",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/job-role-fitment-analysis",
            path: "/fitment-analysis/job-role-fitment-analysis",
            title: "Job Role Fitment Analysis",
            icon: <Target className="w-3 h-3" />,
          },

          {
            segment: "fitment-analysis/job-roles-topic",
            path: "/fitment-analysis/job-roles-topic",
            title: "Job Roles & Topics",
            icon: <Tag className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Report Questions",
    items: [
      {
        segment: "report-questions",
        path: "/report-questions",
        title: "Report Questions",
        icon: <FileText className="w-4 h-4" />,
        children: [
          {
            segment: "report-questions",
            path: "/report-questions",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Website Management",
    items: [
      {
        segment: "contact-sales-dashboard",
        path: "/contact-sales-dashboard",
        title: "Inquiry Management",
        icon: <FileText className="w-4 h-4" />,
        children: [
          {
            segment: "contact-sales-dashboard",
            path: "/contact-sales-dashboard",
            title: "Contact Sales Dashboard",
            icon: <BarChart3 className="w-3 h-3" />,
          },
          {
            segment: "request-demo-dashboard",
            path: "/request-demo-dashboard",
            title: "Request Demo Dashboard",
            icon: <Calendar className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "coupon-management",
        path: "/coupon-management",
        title: "Coupon Management",
        icon: <FileUp className="w-4 h-4" />,
        children: [
          {
            segment: "coupon-management",
            path: "/coupon-management",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "coupon-management/create-coupon",
            path: "/coupon-management/create-coupon",
            title: "Create Coupon",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "global-jobs-management",
        path: "/global-jobs-management",
        title: "Global Job Management",
        icon: <Globe className="w-4 h-4" />,
        children: [
          {
            segment: "global-jobs-management/view-jobs",
            path: "/global-jobs-management/view-jobs",
            title: "View All Jobs",
            icon: <Kanban className="w-4 h-4" />,
          },
        ],
      },
      {
        segment: "career-management",
        path: "/career-management",
        title: "Career Management",
        icon: <BriefcaseBusiness className="w-4 h-4" />,
        children: [
          {
            segment: "career-management/view-jobs",
            path: "/career-management/view-jobs",
            title: "View Jobs",
            icon: <Kanban className="w-4 h-4" />,
          },
          {
            segment: "career-management/post-job",
            path: "/career-management/post-job",
            title: "Post Job",
            icon: <FilePlus className="w-4 h-4" />,
          },
          {
            segment: "career-management/view-applicants",
            path: "/career-management/view-applicants",
            title: "View Applicants",
            icon: <Users className="w-4 h-4" />,
          },
        ],
      },
      {
        segment: "plans",
        path: "/plans",
        title: "Plans Management",
        icon: <Calendar className="w-4 h-4" />,
        children: [
          {
            segment: "plans",
            path: "/plans",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "plans/create",
            path: "/plans/create",
            title: "Create",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
    ],
  },

  {
    title: "Tags Management",
    items: [
      {
        segment: "tags",
        path: "/tags",
        title: "Tags Management",
        icon: <Tag className="w-4 h-4" />,
        children: [
          {
            segment: "tags",
            path: "/tags",
            title: "View All",
            icon: <Eye className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
];

const CLIENT_NAVIGATION: Navigation = [
  {
    title: "Dashboard",
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    title: "Organization Management",
    items: [
      {
        segment: "client/users",
        path: "/client/users",
        title: "Users Management",
        icon: <BookOpen className="w-4 h-4" />,
        children: [
          {
            segment: "client/users",
            path: "/client/users",
            title: "View Users",
            icon: <UserCheck className="w-3 h-3" />,
          },
          {
            segment: "client/create-users",
            path: "/client/create-users",
            title: "Add New Users",
            icon: <UserPlus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/user-groups",
        path: "/client/user-groups",
        title: "Group Management",
        icon: <Users className="w-4 h-4" />,
        children: [
          {
            segment: "client/user-groups",
            path: "/client/user-groups",
            title: "View Groups",
            icon: <UserCheck className="w-3 h-3" />,
          },
          {
            segment: "client/create-groups",
            path: "/client/create-groups",
            title: "Add New Groups",
            icon: <UsersIcon className="w-3 h-3" />,
          },
          {
            segment: "client/create-group-users",
            path: "/client/create-group-users",
            title: "Assign Users",
            icon: <UserPlus className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Assessment Architecture",
    items: [
      {
        segment: "client/sections",
        path: "/client/sections",
        title: "Sections",
        icon: <Notebook className="w-4 h-4" />,
        children: [
          {
            segment: "client/sections",
            path: "/client/sections",
            title: "View Sections",
            icon: <BookOpen className="w-3 h-3" />,
          },
          {
            segment: "client/sections/create",
            path: "/client/sections/create",
            title: "Add New Section",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/patterns",
        path: "/client/patterns",
        title: "Patterns",
        icon: <Puzzle className="w-4 h-4" />,
        children: [
          {
            segment: "client/patterns",
            path: "/client/patterns",
            title: "Patterns",
            icon: <Target className="w-3 h-3" />,
          },
          {
            segment: "client/patterns/create",
            path: "/client/patterns/create",
            title: "Create Pattern",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/assessmentsv2",
        path: "/client/assessmentsv2",
        title: "Assessments",
        icon: <TestTube className="w-4 h-4" />,
        children: [
          {
            segment: "client/assessmentsv2",
            path: "/client/assessmentsv2",
            title: "View Assessments",
            icon: <GraduationCap className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/create",
            path: "/client/assessmentsv2/create",
            title: "Create Assessment",
            icon: <FolderPlus className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/scheduleAssessment",
            path: "/client/assessmentsv2/scheduleAssessment",
            title: "Schedule Assessment",
            icon: <CalendarCheck className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/launchAssessment",
            path: "/client/assessmentsv2/launchAssessment",
            title: "Launch Assessment",
            icon: <Rocket className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/runningAssessment",
            path: "/client/assessmentsv2/runningAssessment",
            title: "Running Assessment",
            icon: <Play className="w-3 h-3" />,
          },
        ],
      },
    ],
  },

  {
    title: "Content Management",
    items: [
      {
        segment: "question-bank-overview",
        path: "/admin/question-bank-overview",
        title: "Question Bank Summary", // New Analytics Dashboard
        icon: <BarChart3 className="w-4 h-4" />,
      },
    ],
  },
  // {
  //   title: "Question Bank Overview",
  //   items: [
  //     {
  //       segment: "question-bank-overview",
  //       path: "/question-bank-overview",
  //       title: "Question Bank Overview",
  //       icon: <BookOpen className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "question-bank-overview/mcq",
  //           path: "/question-bank-overview/mcq",
  //           title: "MCQ Questions",
  //           icon: <HelpCircle className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "question-bank-overview/coding",
  //           path: "/question-bank-overview/coding",
  //           title: "Coding Questions",
  //           icon: <Code className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    title: "Reports & Analytics",
    items: [
      {
        segment: "client/reports",
        path: "/client/reports",
        title: "Reports",
        icon: <BarChart3 className="w-4 h-4" />,
        children: [
          {
            segment: "client/reports/assessment-wise",
            path: "/client/reports/assessment-wise",
            title: "Assessment Wise",
            icon: <BarChart3 className="w-3 h-3" />,
          },
          {
            segment: "client/reports/user-group-wise",
            path: "/client/reports/user-group-wise",
            title: "User Group Wise",
            icon: <Users className="w-3 h-3" />,
          },
          {
            segment: "client/reports/student-wise",
            path: "/client/reports/student-wise",
            title: "Student Wise",
            icon: <FileText className="w-3 h-3" />,
          },
          {
            segment: "client/reports/custom-assessment",
            path: "/client/reports/custom-assessment",
            title: "Custom Assessments",
            icon: <FileText className="w-3 h-3" />,
          },
          {
            segment: "client/reports/make-my-report",
            path: "/client/reports/make-my-report",
            title: "Make My Report",
            icon: <Target className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "fitment-analysis",
        path: "/fitment-analysis",
        title: "Fitment Analysis",
        icon: <TrendingUp className="w-4 h-4" />,
        children: [
          {
            segment: "fitment-analysis/content-fitment-analysis",
            path: "/fitment-analysis/content-fitment-analysis",
            title: "Skill Fitment Analysis",
            icon: <Eye className="w-3 h-3" />,
          },

          {
            segment: "fitment-analysis/company-fitment-analysis",
            path: "/fitment-analysis/company-fitment-analysis",
            title: "Company Fitment Analysis",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/job-role-fitment-analysis",
            path: "/fitment-analysis/job-role-fitment-analysis",
            title: "Job Role Fitment Analysis",
            icon: <Target className="w-3 h-3" />,
          },

          // {
          //   segment: "fitment-analysis/job-roles-topic",
          //   path: "/fitment-analysis/job-roles-topic",
          //   title: "Job Roles & Topics",
          //   icon: <Tag className="w-3 h-3" />,
          // },
        ],
      },
    ],
  },
];

const CONTENT_HEAD_NAVIGATION: Navigation = [
  {
    title: "Overview",
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },

  // --- WORKFORCE MANAGEMENT ---
  {
    title: "Team Management",
    items: [
      {
        segment: "author-management",
        path: "/author-management",
        title: "Authors & Moderators",
        icon: <UserCircle className="w-4 h-4" />,
        children: [
          {
            segment: "author-management/add-author",
            path: "/author-management/add-author",
            title: "Add Author",
            icon: <UserPlus className="w-3 h-3" />,
          },
          {
            segment: "author-management/view-authors",
            path: "/author-management/view-authors",
            title: "View Authors",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "author-management/add-moderator",
            path: "/author-management/add-moderator",
            title: "Add Moderator",
            icon: <Settings className="w-3 h-3" />,
          },
          {
            segment: "author-management/view-moderator",
            path: "/author-management/view-moderator",
            title: "View Moderators",
            icon: <UserCog className="w-3 h-3" />,
          },
          {
            segment: "author-management/summary",
            path: "/author-management/summary",
            title: "Performance Summary", // The comprehensive dashboard we built
            icon: <FileCode className="w-3 h-3" />,
          },
        ],
      },
    ],
  },

  // --- CONTENT REPOSITORY ---
  {
    title: "Content Operations",
    items: [
      {
        segment: "question-bank-overview",
        path: "/admin/question-bank-overview",
        title: "Question Bank Analytics",
        icon: <BarChart3 className="w-4 h-4" />,
      },
      {
        segment: "questions",
        path: "/author/questions", // Access to the global bank
        title: "Global Question Bank",
        icon: <Database className="w-4 h-4" />,
      },
    ],
  },

  // --- QUALITY ASSURANCE ---
  {
    title: "Quality Assurance",
    items: [
      {
        segment: "report-questions",
        path: "/report-questions",
        title: "Reported Issues",
        icon: <FileText className="w-4 h-4" />,
        children: [
          {
            segment: "report-questions",
            path: "/report-questions",
            title: "View All Reports",
            icon: <Eye className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
];

const SUPER_ADMIN_NAVIGATION: Navigation = [
  {
    title: "Dashboard", // ✅ Changed from Overview
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    title: "Organization Management", // ✅ Grouped Title
    items: [
      // --- 1. Consultant Management (Nested) ---
      {
        segment: "consultants",
        path: "/super-admin/view-consultants", // Default action
        title: "Consultants",
        icon: <UserCheck className="w-4 h-4" />,
        children: [
          {
            segment: "add-consultant",
            path: "/super-admin/add-consultants",
            title: "Onboard New",
            icon: <UserPlus className="w-3 h-3" />,
          },
          {
            segment: "view-consultants",
            path: "/super-admin/view-consultants",
            title: "Directory",
            icon: <Users className="w-3 h-3" />,
          },
          {
            segment: "assign-consultant",
            path: "/super-admin/assign-consultants",
            title: "Assign Consultants",
            icon: <UserCheck className="w-3 h-3" />,
          },
        ],
      },
      // --- 2. Business Unit Management (Nested) ---
      {
        segment: "business-units",
        path: "/super-admin/view-business-units", // Default action
        title: "Business Units",
        icon: <Building2 className="w-4 h-4" />,
        children: [
          {
            segment: "add-bu",
            path: "/super-admin/add-business-unit",
            title: "Register Unit",
            icon: <PlusCircle className="w-3 h-3" />,
          },
          {
            segment: "view-bu",
            path: "/super-admin/view-business-units",
            title: "Unit Overview",
            icon: <Eye className="w-3 h-3" />,
          },
        ],
      },
      // --- 3. Group Management (✅ Added) ---
      {
        segment: "groups",
        path: "/super-admin/view-groups", // Default to view
        title: "Groups",
        icon: <LayoutGrid className="w-4 h-4" />,
        children: [
          {
            segment: "add-group",
            path: "/super-admin/add-group",
            title: "Create Group",
            icon: <PlusSquare className="w-3 h-3" />,
          },
          {
            segment: "view-groups",
            path: "/super-admin/view-groups",
            title: "Group Directory",
            icon: <List className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Assessment Architecture",
    items: [
      {
        segment: "client/sections",
        path: "/client/sections",
        title: "Sections",
        icon: <Notebook className="w-4 h-4" />,
        children: [
          {
            segment: "client/sections",
            path: "/client/sections",
            title: "View Sections",
            icon: <BookOpen className="w-3 h-3" />,
          },
          {
            segment: "client/sections/create",
            path: "/client/sections/create",
            title: "Add New Section",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/patterns",
        path: "/client/patterns",
        title: "Patterns",
        icon: <Puzzle className="w-4 h-4" />,
        children: [
          {
            segment: "client/patterns",
            path: "/client/patterns",
            title: "Patterns",
            icon: <Target className="w-3 h-3" />,
          },
          {
            segment: "client/patterns/create",
            path: "/client/patterns/create",
            title: "Create Pattern",
            icon: <Plus className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "client/assessmentsv2",
        path: "/client/assessmentsv2",
        title: "Assessments",
        icon: <TestTube className="w-4 h-4" />,
        children: [
          {
            segment: "client/assessmentsv2",
            path: "/client/assessmentsv2",
            title: "View Assessments",
            icon: <GraduationCap className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/create",
            path: "/client/assessmentsv2/create",
            title: "Create Assessment",
            icon: <FolderPlus className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/scheduleAssessment",
            path: "/client/assessmentsv2/scheduleAssessment",
            title: "Schedule Assessment",
            icon: <CalendarCheck className="w-3 h-3" />,
          },
          // {
          //   segment: "client/assessmentsv2/launchAssessment",
          //   path: "/client/assessmentsv2/launchAssessment",
          //   title: "Launch Assessment",
          //   icon: <Rocket className="w-3 h-3" />,
          // },
          {
            segment: "client/assessmentsv2/runningAssessment",
            path: "/client/assessmentsv2/runningAssessment",
            title: "Running Assessment",
            icon: <Play className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Reports & Analytics",
    items: [
      {
        segment: "client/reports",
        path: "/client/reports",
        title: "Reports",
        icon: <BarChart3 className="w-4 h-4" />,
        children: [
          {
            segment: "client/reports/assessment-wise",
            path: "/client/reports/assessment-wise",
            title: "Assessment Wise",
            icon: <BarChart3 className="w-3 h-3" />,
          },
          {
            segment: "client/reports/user-group-wise",
            path: "/client/reports/user-group-wise",
            title: "User Group Wise",
            icon: <Users className="w-3 h-3" />,
          },
          {
            segment: "super-admin/business-unit-wise-report",
            path: "/super-admin/business-unit-wise-report",
            title: "Business Unit Wise",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "super-admin/summary-report",
            path: "/super-admin/summary-report",
            title: "Summary Reports",
            icon: <FileText className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "fitment-analysis",
        path: "/fitment-analysis",
        title: "Fitment Analysis",
        icon: <TrendingUp className="w-4 h-4" />,
        children: [
          {
            segment: "fitment-analysis/content-fitment-analysis",
            path: "/fitment-analysis/content-fitment-analysis",
            title: "Skill Fitment Analysis",
            icon: <Eye className="w-3 h-3" />,
          },

          {
            segment: "fitment-analysis/company-fitment-analysis",
            path: "/fitment-analysis/company-fitment-analysis",
            title: "Company Fitment Analysis",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/job-role-fitment-analysis",
            path: "/fitment-analysis/job-role-fitment-analysis",
            title: "Job Role Fitment Analysis",
            icon: <Target className="w-3 h-3" />,
          },

          // {
          //   segment: "fitment-analysis/job-roles-topic",
          //   path: "/fitment-analysis/job-roles-topic",
          //   title: "Job Roles & Topics",
          //   icon: <Tag className="w-3 h-3" />,
          // },
        ],
      },
    ],
  },
];

const BUSINESS_UNIT_NAVIGATION: Navigation = [
  {
    title: "Dashboard", // ✅ Changed from Overview
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    title: "Organization Management", // ✅ Grouped Title
    items: [
      // --- 1. Consultant Management (Nested) ---
      {
        segment: "consultants",
        path: "/business-unit/view-consultants", // Default action
        title: "Consultants",
        icon: <UserCheck className="w-4 h-4" />,
        children: [
          {
            segment: "add-consultant",
            path: "/business-unit/add-consultants",
            title: "Onboard New",
            icon: <UserPlus className="w-3 h-3" />,
          },
          {
            segment: "view-consultants",
            path: "/business-unit/view-consultants",
            title: "Directory",
            icon: <Users className="w-3 h-3" />,
          },
          // {
          //   segment: "assign-consultant",
          //   path: "/business-unit/assign-consultants",
          //   title: "Assign Consultants",
          //   icon: <UserCheck className="w-3 h-3" />,
          // },
        ],
      },
      {
        segment: "groups",
        path: "/business-unit/group-management", // Default route when clicking the parent
        title: "Groups",
        icon: <LayoutGrid className="w-4 h-4" />,
        children: [
          {
            segment: "group-management",
            path: "/business-unit/group-management",
            title: "Manage Groups", // Component 1: Displays all groups, locks, and stats
            icon: <List className="w-3 h-3" />,
          },
          {
            segment: "assign-group",
            path: "/super-admin/assign-group-consultants",
            title: "Assign Group", // Component 2: Assigns consultants to the groups
            icon: <PlusSquare className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Assessment Architecture",
    items: [
      {
        segment: "client/assessmentsv2",
        path: "/client/assessmentsv2",
        title: "Assessments",
        icon: <TestTube className="w-4 h-4" />,
        children: [
          {
            segment: "client/assessmentsv2",
            path: "/client/assessmentsv2",
            title: "View Assessments",
            icon: <GraduationCap className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/launchAssessment",
            path: "/client/assessmentsv2/launchAssessment",
            title: "Launch Assessment",
            icon: <Rocket className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/runningAssessment",
            path: "/client/assessmentsv2/runningAssessment",
            title: "Running Assessment",
            icon: <Play className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Reports & Analytics",
    items: [
      {
        segment: "client/reports",
        path: "/client/reports",
        title: "Reports",
        icon: <BarChart3 className="w-4 h-4" />,
        children: [
          {
            segment: "client/reports/assessment-wise",
            path: "/client/reports/assessment-wise",
            title: "Assessment Wise",
            icon: <BarChart3 className="w-3 h-3" />,
          },
          {
            segment: "client/reports/user-group-wise",
            path: "/client/reports/user-group-wise",
            title: "User Group Wise",
            icon: <Users className="w-3 h-3" />,
          },
        ],
      },
      {
        segment: "fitment-analysis",
        path: "/fitment-analysis",
        title: "Fitment Analysis",
        icon: <TrendingUp className="w-4 h-4" />,
        children: [
          {
            segment: "fitment-analysis/content-fitment-analysis",
            path: "/fitment-analysis/content-fitment-analysis",
            title: "Skill Fitment Analysis",
            icon: <Eye className="w-3 h-3" />,
          },

          {
            segment: "fitment-analysis/company-fitment-analysis",
            path: "/fitment-analysis/company-fitment-analysis",
            title: "Company Fitment Analysis",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/job-role-fitment-analysis",
            path: "/fitment-analysis/job-role-fitment-analysis",
            title: "Job Role Fitment Analysis",
            icon: <Target className="w-3 h-3" />,
          },

          // {
          //   segment: "fitment-analysis/job-roles-topic",
          //   path: "/fitment-analysis/job-roles-topic",
          //   title: "Job Roles & Topics",
          //   icon: <Tag className="w-3 h-3" />,
          // },
        ],
      },
    ],
  },
];

const ENTERPRISE_ADMIN_NAVIGATION: Navigation = [
  {
    title: "Dashboard", // ✅ Changed from Overview
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    title: "Procurement & Billing",
    items: [
      {
        segment: "licenses",
        path: "/enterprise-admin/view-licenses", // Default path when clicking parent
        title: "Licenses",
        icon: <ShoppingCart className="w-4 h-4" />,
        children: [
          {
            segment: "add-licenses",
            path: "/enterprise-admin/add-licenses", // Matched Route
            title: "Buy Licenses",
            icon: <PlusSquare className="w-3 h-3" />,
          },
          {
            segment: "view-licenses",
            path: "/enterprise-admin/view-licenses", // Matched Route
            title: "Purchase History",
            icon: <List className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Insights",
    items: [
      {
        segment: "super-admin/summary-report",
        path: "/super-admin/summary-report",
        title: "Organization Overview",
        icon: <LayoutDashboard className="w-4 h-4" />,
      },
    ],
  },
];

const AUTHOR_NAVIGATION: Navigation = [
  {
    title: "Dashboard",
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    // Renamed from "Assessment Library" to "Question Management"
    title: "Question Management",
    items: [
      {
        segment: "questions",
        path: "/author/questions",
        title: "Question Bank",
        icon: <Database className="w-4 h-4" />,
        children: [
          {
            segment: "questions",
            path: "/author/questions",
            title: "Repository", // Professional term for "View All"
            icon: <Library className="w-3 h-3" />,
          },
          {
            segment: "unified-question-creator",
            path: "/author/unified-question-creator",
            title: "Author New", // Professional term for "Create"
            icon: <PenTool className="w-3 h-3" />,
          },
          {
            segment: "csv-upload",
            path: "/author/csv-upload",
            title: "Bulk Import", // Professional term for "CSV Upload"
            icon: <FileUp className="w-3 h-3" />,
          },
          {
            segment: "csv-upload-history",
            path: "/author/csv-upload-history",
            title: "Import History", // Professional term for "CSV Upload History"
            icon: <History className="w-3 h-3" />,
          },
          {
            segment: "coding-to-debugging-studio",
            path: "/author/codingToDebuggingStudio",
            title: "Debug Studio", // Short, punchy, and functional
            icon: <Wand2 className="w-4 h-4" />, // Professional "magic/conversion" icon
          },
        ],
      },
    ],
  },
  // {
  //   title: "Authored Content",
  //   items: [
  //     {
  //       segment: "coding-problems",
  //       path: "/coding-problems",
  //       title: "Coding Problems",
  //       icon: <Code className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "coding-problems",
  //           path: "/coding-problems",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "coding-problems/create",
  //           path: "/coding-problems/create",
  //           title: "Create",
  //           icon: <Plus className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "coding-problems/csv-upload",
  //           path: "/coding-problems/csv-upload",
  //           title: "CSV Upload",
  //           icon: <FileUp className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //     {
  //       segment: "mcq-problems",
  //       path: "/mcq-problems",
  //       title: "MCQ Problems",
  //       icon: <HelpCircle className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "mcq-problems",
  //           path: "/mcq-problems",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "mcq-problems/create",
  //           path: "/mcq-problems/create",
  //           title: "Create",
  //           icon: <Plus className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "mcq-problems/csv-upload",
  //           path: "/mcq-problems/csv-upload",
  //           title: "CSV Upload",
  //           icon: <FileUp className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: "Pragna-AI Content",
  //   items: [
  //     {
  //       segment: "coding-problems/ai",
  //       path: "/coding-problems/ai",
  //       title: "AI Coding Problems",
  //       icon: <BrainCircuit className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "coding-problems/ai",
  //           path: "/coding-problems/ai",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "coding-problems/ai/create",
  //           path: "/coding-problems/ai/create",
  //           title: "Create",
  //           icon: <Plus className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //     {
  //       segment: "mcq-problems/ai",
  //       path: "/mcq-problems/ai",
  //       title: "AI MCQ Problems",
  //       icon: <Sparkles className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "mcq-problems/ai",
  //           path: "/mcq-problems/ai",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //         {
  //           segment: "mcq-problems/ai/create",
  //           path: "/mcq-problems/ai/create",
  //           title: "Create",
  //           icon: <Plus className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //   ],
  // },
];

const MODERATOR_NAVIGATION: Navigation = [
  {
    title: "Dashboard",
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },
  {
    title: "Moderation",
    items: [
      {
        segment: "questions",
        path: "/moderator/questions",
        title: "Review Queue",
        icon: <ClipboardCheck className="w-4 h-4" />,
      },
    ],
  },
  // {
  //   title: "Moderation",
  //   items: [
  //     {
  //       segment: "mcq-problems/assign-moderator",
  //       path: "/mcq-problems/assign-moderator",
  //       title: "MCQ Problems",
  //       icon: <HelpCircle className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "mcq-problems/assign-moderator",
  //           path: "/mcq-problems/assign-moderator",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //     {
  //       segment: "coding-problems/assign-moderator",
  //       path: "/coding-problems/assign-moderator",
  //       title: "Coding Problems",
  //       icon: <Code className="w-4 h-4" />,
  //       children: [
  //         {
  //           segment: "coding-problems/assign-moderator",
  //           path: "/coding-problems/assign-moderator",
  //           title: "View All",
  //           icon: <Eye className="w-3 h-3" />,
  //         },
  //       ],
  //     },
  //   ],
  // },
];

const STUDENT_NAVIGATION: Navigation = [
  {
    title: "Dashboard",
    items: [
      {
        segment: "profile",
        path: "/profile",
        title: "My Profile",
        icon: <User className="w-4 h-4" />,
      },
    ],
  },

  // --- NEW SEPARATE SECTION: CAREER PORTAL ---
  {
    title: "Career Portal",
    items: [
      {
        segment: "student/jobsManagement",
        path: "/student/jobsManagement",
        title: "Jobs Management",
        icon: <Briefcase className="w-4 h-4" />,
      },
    ],
  },

  {
    title: "Assessments",
    items: [
      {
        segment: "client/assessmentsv2",
        path: "/client/assessmentsv2",
        title: "Assessments",
        icon: <TestTube className="w-4 h-4" />,
        children: [
          {
            segment: "client/assessmentsv2",
            path: "/client/assessmentsv2",
            title: "View Assessments",
            icon: <GraduationCap className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/create",
            path: "/client/assessmentsv2/create",
            title: "Create Assessment",
            icon: <FolderPlus className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/scheduleAssessment",
            path: "/client/assessmentsv2/scheduleAssessment",
            title: "Schedule Assessment",
            icon: <CalendarCheck className="w-3 h-3" />,
          },
          {
            segment: "client/assessmentsv2/launchAssessment",
            path: "/client/assessmentsv2/launchAssessment",
            title: "Launch Assessment",
            icon: <Rocket className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
  {
    title: "Reports",
    items: [
      {
        segment: "client/reports/student-wise",
        path: "/client/reports/student-wise",
        title: "Your Reports",
        icon: <FileText className="w-3 h-3" />,
      },
    ],
  },
  {
    title: "Fitment Analysis",
    items: [
      {
        segment: "fitment-analysis",
        path: "/fitment-analysis",
        title: "Fitment Analysis",
        icon: <TrendingUp className="w-4 h-4" />,
        children: [
          {
            segment: "fitment-analysis/content-fitment-analysis",
            path: "/fitment-analysis/content-fitment-analysis",
            title: "Skill Fitment Analysis",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/company-fitment-analysis",
            path: "/fitment-analysis/company-fitment-analysis",
            title: "Company Fitment Analysis",
            icon: <Building className="w-3 h-3" />,
          },
          {
            segment: "fitment-analysis/job-role-fitment-analysis",
            path: "/fitment-analysis/job-role-fitment-analysis",
            title: "Job Role Fitment Analysis",
            icon: <Target className="w-3 h-3" />,
          },
        ],
      },
    ],
  },
];

// Function to get role-based navigation items
export const getNavigationItems = (role: UserRole, user?: any): Navigation => {
  let currentUser = user;

  if (!currentUser || !currentUser.accountType) {
    try {
      const stored = localStorage.getItem("user");
      if (stored) {
        const parsed = JSON.parse(stored);
        currentUser = { ...parsed, ...currentUser };
      }
    } catch (e) {
      console.error("Error parsing user from localstorage");
    }
  }

  // Define the Agency specific section
  const AGENCY_JOBS_SECTION = {
    title: "Agency Jobs Management",
    items: [
      {
        segment: "agency/agency-jobs",
        path: "/agency/post-job",
        title: "Recruitment Portal",
        icon: <Briefcase className="w-4 h-4" />,
        children: [
          {
            segment: "agency/post-job",
            path: "/agency/post-job",
            title: "Post Job",
            icon: <PlusCircle className="w-3 h-3" />,
          },
          {
            segment: "agency/manage-jobs",
            path: "/agency/manage-jobs",
            title: "View Jobs",
            icon: <Eye className="w-3 h-3" />,
          },
          {
            segment: "agency/edit-job",
            path: "/agency/edit-job",
            title: "Edit Job",
            icon: <Edit className="w-3 h-3" />,
          },
          {
            segment: "agency/share-job-report",
            path: "/agency/share-job-report",
            title: "Share Job Reports",
            icon: <Eye className="w-3 h-3" />,
          },
        ],
      },
    ],
  };

  // Define the Candidate Management section for HR Agency
  const CANDIDATES_MANAGEMENT_ITEM = {
    segment: "client/view-candidates",
    path: "/client/view-candidates",
    title: "Candidates Management",
    icon: <BookOpen className="w-4 h-4" />,
    children: [
      {
        segment: "client/view-candidates",
        path: "/client/view-candidates",
        title: "View Candidates",
        icon: <UserCheck className="w-3 h-3" />,
      },
      {
        segment: "client/add-candidates",
        path: "/client/add-candidates",
        title: "Add New Candidates",
        icon: <UserPlus className="w-3 h-3" />,
      },
    ],
  };

  switch (role) {
    case "admin":
      return ADMIN_NAVIGATION;

    case "client":
      const isRA = currentUser?.accountType === "standard";

      if (isRA) {
        // 1. Modify standard sections for HR Agency
        let raNav = CLIENT_NAVIGATION.map((section) => {
          if (section.title === "Organization Management") {
            // Filter out Group Management and Users Management, then add Candidates and Employers
            const baseItems = section.items.filter(
              (item) =>
                item.title !== "Group Management" &&
                item.title !== "Users Management",
            );

            return {
              ...section,
              items: [
                CANDIDATES_MANAGEMENT_ITEM, // 👈 Added Candidate Management here
                ...baseItems,
                {
                  segment: "client/employers",
                  path: "/client/view-employers",
                  title: "Employer Management",
                  icon: <Building className="w-4 h-4" />,
                  children: [
                    {
                      segment: "client/view-employers",
                      path: "/client/view-employers",
                      title: "View Employers",
                      icon: <Eye className="w-3 h-3" />,
                    },
                    {
                      segment: "client/add-employers",
                      path: "/client/add-employers",
                      title: "Add Employers",
                      icon: <Plus className="w-3 h-3" />,
                    },
                  ],
                },
              ],
            };
          }
          return section;
        });

        // 2. Insert Agency Jobs Management section above "Assessment Architecture"
        const assessmentIndex = raNav.findIndex(
          (s) => s.title === "Assessment Architecture",
        );
        if (assessmentIndex !== -1) {
          raNav.splice(assessmentIndex, 0, AGENCY_JOBS_SECTION);
        }

        return raNav;
      }
      // Standard Client
      return CLIENT_NAVIGATION;

    case "author":
      return AUTHOR_NAVIGATION;
    case "moderator":
      return MODERATOR_NAVIGATION;

    case "content_head":
      return CONTENT_HEAD_NAVIGATION;

    case "super_admin":
      return SUPER_ADMIN_NAVIGATION;

    case "enterprise_admin":
      return ENTERPRISE_ADMIN_NAVIGATION;

    case "business_unit":
      return BUSINESS_UNIT_NAVIGATION;

    case "student":
      const nav = [...STUDENT_NAVIGATION];
      const isUnlimited =
        currentUser?.planName?.toLowerCase().includes("unlimited") ||
        currentUser?.accessLimits?.assessmentsAllowed === -1;

      if (isUnlimited) {
        nav.push({
          title: "Career & Jobs",
          items: [
            {
              segment: "view-jobs",
              path: "/view-jobs",
              title: "View Jobs",
              icon: <Briefcase className="w-4 h-4" />,
              children: [
                {
                  segment: "view-jobs",
                  path: "/view-jobs",
                  title: "Applied Jobs",
                  icon: <Eye className="w-3 h-3" />,
                },
              ],
            },
          ],
        });
      }
      return nav;

    default:
      return [];
  }
};
